/**
 * UD Event Design Tool Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {EventTemplate} from '../models/EventTemplate';
import type {EventType} from '../models/EventType';

export interface GetTemplate$Request {
    eventSource: string;
    eventType: EventType;
}

export interface GetTemplate$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getTemplateRequest = createAction<PayloadData<void, GetTemplate$Request>>('EVENT_TEMPLATE_CONTROLLER__GET_TEMPLATE__REQUEST');
export const getTemplateSuccess = createAction<PayloadData<EventTemplate, GetTemplate$Request>>('EVENT_TEMPLATE_CONTROLLER__GET_TEMPLATE__SUCCESS');
export const getTemplateFailure = createAction<PayloadData<Error, GetTemplate$Request, true>>('EVENT_TEMPLATE_CONTROLLER__GET_TEMPLATE__FAILURE');

export const getTemplateActions = [
    getTemplateRequest,
    getTemplateSuccess,
    getTemplateFailure
] as const;

/**
 * @param {string} meta.eventSource Event source
 * @param {EventType} meta.eventType Event type
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getTemplate = (meta: GetTemplate$Request, config?: GetTemplate$Config) => {
    const TRANSPORT_GET_PARAMS = {
        eventSource: meta.eventSource,
        eventType: meta.eventType,
    };
    return {
        CALL_API: {
            types: getTemplateActions,
            method: ApiMethods.GET,
            endpoint: `/events/template`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

